module.exports = __webpack_public_path__ + "img/two2Blue.7980c39a.jpg";